import React from "react";
import Typography from "material-ui/Typography";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
const SummaryRightTable = props => (
  <Table className={props.classes.table}>
    <TableBody>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}></TableCell>
        <TableCell className={props.classes.tablecontent_first}></TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          <Typography className={props.classes.delayText} color="inherit">
            {props.translate("result_propagation_delay") + ":"}
          </Typography>
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          <table>
            <tr
              style={{
                background: "#f2f2f2"
              }}
            >
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "15px 35px 15px 35px"
                }}
              >
                {props.translate("result_min")}
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "15px 35px 15px 35px"
                }}
              >
                {props.translate("result_avg")}
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "15px 35px 15px 35px"
                }}
              >
                {props.translate("result_max")}
              </th>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "center"
                }}
              >
                {props.subtestUptimeResults.rttmin.toFixed(3)}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "center"
                }}
              >
                {props.subtestUptimeResults.rttavg.toFixed(3)}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "center"
                }}
              >
                {props.subtestUptimeResults.rttmax.toFixed(3)}
              </td>
            </tr>
          </table>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("jitter") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          <table>
            <tr
              style={{
                background: "#f2f2f2"
              }}
            >
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "15px 35px 15px 35px"
                }}
              >
                {props.translate("result_min")}
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "15px 35px 15px 35px"
                }}
              >
                {props.translate("result_avg")}
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "15px 35px 15px 35px"
                }}
              >
                {props.translate("result_max")}
              </th>
            </tr>
            <tr>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "center"
                }}
              >
                {Math.round(props.subtestUptimeResults.jittermin)}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "center"
                }}
              >
                {Math.round(props.subtestUptimeResults.jitteravg)}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "center"
                }}
              >
                {Math.round(props.subtestUptimeResults.jittermax)}
              </td>
            </tr>
          </table>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);
export default withStyles(styles)(SummaryRightTable);
